import React from 'react'
import { CgCheckO, CgCloseO, CgTrash } from 'react-icons/cg'
import tw from 'twin.macro'
import { format } from 'date-fns'

import { Switch } from 'common/components/Switch/Switch'
import { Tooltip } from 'common/components/Tooltip/Tooltip'
import { getIsAlwaysActive, getIsCouponActive } from 'modules/ProductInfo/utils/utils'
import { fromDayAnchorToLocalDate, fromExpirationAnchorToLocalDate } from 'modules/ProductInfo/utils/dateUtils'

const PromoCoupon = React.memo(({ promo, coupon, handleDeletePromo, handleUpdateAutoApplied }) => {
  const startDate = fromDayAnchorToLocalDate(
    typeof coupon?.startDate !== 'undefined' ? coupon?.startDate : promo?.startDate
  )
  const expirationDate = fromExpirationAnchorToLocalDate(
    typeof coupon?.expiration !== 'undefined' ? coupon?.expiration : promo?.expiration
  )
  const isCouponActive = getIsCouponActive({ promo, coupon })
  const alwaysActive = getIsAlwaysActive({ promo, coupon })

  return (
    <div className='group relative flex rounded-lg border-2 border-gray-200 bg-white mb-2.5 last:mb-0'>
      <div className='flex flex-1 items-start '>
        <div className='flex flex-col flex-1 px-2.5 py-2'>
          <p className='text-sm font-medium mb-1'>{coupon?.name || 'Coupon name'}</p>
          <span className='text-xs font-medium text-gray-500'>
            {`Code: ${promo.stripeCouponId}` || '(couponid-autogenerated)'}
          </span>
        </div>
        <div className='flex flex-col px-2.5 py-2 w-2/12'>
          <p className='text-sm font-medium mb-1'>Start</p>

          <span className='text-xs font-medium text-gray-500'>
            {alwaysActive ? 'Always Valid' : startDate ? format(startDate, 'M/d/y') : 'N/A'}
          </span>
        </div>
        <div className='flex flex-col px-2.5 py-2 w-2/12'>
          <p className='text-sm font-medium mb-1'>End</p>
          <span className='text-xs font-medium text-gray-500'>
            {alwaysActive ? 'Always Valid' : expirationDate ? format(expirationDate, 'M/d/y') : 'N/A'}
          </span>
        </div>
        <div className='flex flex-col px-2.5 py-2'>
          <p className='text-sm font-medium mb-1'>Auto-applied</p>
          <Switch
            onChange={(e) => {
              const isAutoApplied = Boolean(e?.target?.checked)
              handleUpdateAutoApplied({ isAutoApplied, stripeCouponId: promo?.stripeCouponId })
            }}
            isChecked={Boolean(promo.isAutoApplied)}
            switchOuterClasses='!w-7 !h-[18px]'
            switchInnerClasses='!w-2.5 !h-2.5'
          />
        </div>
        <div className='flex flex-col items-center px-2.5 py-2'>
          <p className='text-sm font-medium mb-1'>Active</p>
          <span className='text-xs'>
            {isCouponActive ? (
              <CgCheckO className='w-4 h-4 text-tGreen' />
            ) : (
              <CgCloseO className='w-4 h-4 text-gray-500' />
            )}
          </span>
        </div>
      </div>
      <div css={actionContainerClasses} className='group-hover:visible'>
        <Tooltip content='Delete'>
          <CgTrash
            className='cursor-pointer w-[18px] h-[18px] text-gray-500 hover:text-tRed'
            onClick={() => handleDeletePromo({ stripeCouponId: promo?.stripeCouponId })}
          />
        </Tooltip>
      </div>
    </div>
  )
})

export default PromoCoupon

export const actionContainerClasses = tw`
  invisible absolute 
  z-20 right-2 
  top-2 flex 
  items-center py-1 
  px-1.5 rounded-md 
  border-[1px] bg-white 
  border-gray-200 shadow-sm
`
